import React from 'react';
import { Button } from './ui/button';

export function MobileBookingActionBar({
  children,
  onClick,
  disabled = false,
  buttonClassName = '',
  dataTestId = 'mobile-booking-action-button',
}) {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[70] border-t border-slate-200/80 bg-white/95 px-4 pt-3 shadow-[0_-14px_34px_rgba(15,23,42,0.08)] backdrop-blur-xl supports-[backdrop-filter]:bg-white/85 md:hidden"
      style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 0.75rem)' }}
      data-testid="mobile-booking-action-bar"
    >
      <div className="mx-auto max-w-3xl">
        <Button
          onClick={onClick}
          disabled={disabled}
          className={`h-14 w-full rounded-2xl text-base font-semibold shadow-lg ${buttonClassName}`}
          data-testid={dataTestId}
        >
          {children}
        </Button>
      </div>
    </div>
  );
}